import apiClient from '../api-client';

export const getRecommendedWines = () => apiClient.get('wine/recommended').then(res => res.data);
export const getWine = (winerySlug, slug) => apiClient.get('wine/' + winerySlug + '/' + slug).then(res => res.data);
export const searchWines = (query) => apiClient.get('wine/search', { params: { query }}).then(res => res.data);
